import { useContext, useState } from "react";
import { useAsyncEffect } from "../../../hooks/UseAsyncEffect"
import { toCurrency, toFormattedDate } from "../../../utilities/FormatHelpers";
import { AccountContext } from "../AccountContext";


export function RegularPaymentPaymentHistory(props: { lastUpdatedDate }) {
  const { accountId, regularPaymentService, setError } = useContext(AccountContext);
  const [paymentHistory, setPaymentHistory] = useState<[]>();

  useAsyncEffect(async () => {
    try {
      var paymentHistory = await regularPaymentService.getPaymentHistory(accountId);
      setPaymentHistory(paymentHistory?.history);
    }
    catch (error) {
      setError(error);
    }
  }, [accountId, props.lastUpdatedDate]);

  return (
    <>
      <h2>Payment History</h2>
      {!paymentHistory || paymentHistory.length == 0
        ? <div>No payment history found</div>
        :
        <table className="ui compact table" style={{ marginBottom: "20px" }}>
          <thead>
            <tr>
              <th>Sort Code</th>
              <th>Account Number</th>
              <th>Payment Type </th>
              <th>Amount</th>
              <th>Reference</th>
              <th>Adjustment Type</th>
              <th>Adjustment Days</th>
              <th>Collection Date</th>
              <th>Due Date</th>
              <th>Billing Period Id</th>
              <th>Regular Payment Transaction Id</th>
              <th>Credit Release</th>
              <th>Credit Release Date</th>
              <th>Reversal Reason</th>
              <th>Reversal Date</th>
            </tr>
          </thead>
          <tbody>
            {paymentHistory.map((h: any) => (
              <tr key={`${h.billingPeriodId}`}>
                <td>{h.sortCode}</td>
                <td>{h.bankAccountNumber}</td>
                <td>{h.paymentType}</td>
                <td>{toCurrency(h?.amount?.value)}</td>
                <td>{h.reference}</td>
                <td>{h.collectionDateAdjustment.type}</td>
                <td>{h.collectionDateAdjustment.days}</td>              
                <td>{toFormattedDate(h.collectionDate)}</td>
                <td>{toFormattedDate(h.statementDueDate)}</td>
                <td>{h.billingPeriodId}</td>
                <td>{h.regularPaymentTransactionId}</td>
                <td>{h.creditRelease}</td>
                <td>{toFormattedDate(h.creditReleasedDate)}</td>
                <td>{h.reversal?.reason}</td>
                <td>{toFormattedDate(h.reversal?.date)}</td>
              </tr>
            ))}
          </tbody>
        </table>}
    </>)
}